import { AfterViewInit, Component, OnDestroy, OnInit } from '@angular/core';
import { ModalController } from '@ionic/angular';
import { asyncScheduler } from 'rxjs';

@Component({
  selector: 'app-received-life',
  templateUrl: './received-life.page.html',
  styleUrls: ['./received-life.page.scss'],
})
export class ReceivedLifePage implements OnInit, AfterViewInit, OnDestroy {

  public heart = false;

  constructor(
    private modalCtrl: ModalController
  ) { }

  ngOnInit() {
    asyncScheduler.schedule(() => this.heart = true, 100);
  }

  ngAfterViewInit() {
  }

  ngOnDestroy() {
  }

  public onClose = () => this.modalCtrl.dismiss(true);

}
